import TableRow from "src/components/Shared/Table/TableRow";
import TRBody from "src/components/Shared/Table/TRBody";
import Button from "src/components/Shared/Buttons/Button";
import Badge from "src/components/ServerMonitoring/Badge";
import { confidenceStyles, formatDateTime, formatDuration, formatPercent, incidentStatusStyles } from "src/helpers/serverMonitorHelper";

const DateCell = ({ date }) =>
  date ? (
    <div className="flex flex-col text-xs text-gray-900">
      {formatDateTime(date, "MMM D, YYYY")} <span className="text-gray-400">{formatDateTime(date, "h:mm:ss A")}</span>
    </div>
  ) : (
    <span className="text-xs text-gray-300">—</span>
  );

const CrashIncidentEntry = ({ incident, onView }) => {
  const status = incidentStatusStyles[incident?.status] || incidentStatusStyles.crashed;
  const confidence = confidenceStyles[incident?.reason_confidence] || confidenceStyles.unknown;

  return (
    <TableRow
      isHoverable
      keyId={incident?._id}>
      <TRBody onClick={() => onView(incident)}>
        <DateCell date={incident?.occurred_at || incident?.detected_at} />
      </TRBody>
      <TRBody
        className="hidden md:table-cell"
        onClick={() => onView(incident)}>
        <DateCell date={incident?.recovered_at} />
      </TRBody>
      <TRBody
        className="hidden whitespace-nowrap text-xs md:table-cell"
        onClick={() => onView(incident)}>
        {incident?.status === "recovered" ? formatDuration(incident?.downtime_seconds, incident?.downtime_is_upper_bound) : <span className="text-red-600">Ongoing</span>}
      </TRBody>
      <TRBody
        className="max-w-[280px] break-normal text-xs text-gray-900"
        onClick={() => onView(incident)}>
        {incident?.reason || "—"}
        {incident?.restart?.count > 1 && <div className="text-gray-400">{incident.restart.count} restarts</div>}
      </TRBody>
      <TRBody
        className="hidden lg:table-cell"
        onClick={() => onView(incident)}>
        <Badge
          label={confidence.label}
          className={confidence.badge}
        />
      </TRBody>
      <TRBody
        className="hidden text-xs lg:table-cell"
        onClick={() => onView(incident)}>
        {formatPercent(incident?.memory?.last_before_crash ?? incident?.memory?.max_before_crash)}
      </TRBody>
      <TRBody onClick={() => onView(incident)}>
        <Badge
          label={status.label}
          className={status.badge}
        />
      </TRBody>
      <TRBody className="text-right">
        <Button
          version="default"
          type="button"
          className="whitespace-nowrap text-sm font-medium text-highlightColor hover:underline"
          onClick={() => onView(incident)}>
          View Details
        </Button>
      </TRBody>
    </TableRow>
  );
};

export default CrashIncidentEntry;
